/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function ChartDown({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M13.424 12.024a.598.598 0 0 0 .176-.417V7.599a.6.6 0 1 0-1.2 0v2.552L8.424 6.175a.6.6 0 0 0-.848 0L6 7.75 2.424 4.175a.6.6 0 0 0-.848.848l4 4a.6.6 0 0 0 .848 0L8 7.448l3.551 3.551H9a.6.6 0 1 0 0 1.2h4a.599.599 0 0 0 .424-.175Z" /></svg>;
}
;